<template>
    <div class="home-model-upload">
        <div v-if="noFilesSelected"  class="upload-no-file-selected">
            <div class="upload-no-file-selected-content" >
                <b-upload v-model="dropFiles" id="upload-file-control"
                          multiple
                          drag-drop>
                        <div class=" center-upload-content" id="v-step-0-4">
                            <img :src='dummy_profile' alt="" class="upload-icon"/>
                            <p>Drop your files here or click to upload</p>
                        </div>
                </b-upload>
            </div>
        </div>
        <div v-else class="upload-files-selected">

            <div class="upload-more">

                <b-upload v-model="dropFiles" id="upload-file-control" class="upload-more-content"
                          multiple
                          drag-drop>
                    <div class=" center-upload-content">

                        <div class="content has-text-centered">
                            <p>
                                <b-icon
                                        icon="upload"
                                        type="is-primary"
                                        size="is-large">
                                </b-icon>
                            </p>
                            <p>Click to add more files</p>
                        </div>
                    </div>
                </b-upload>
            </div>

            <div class="content-to-upload">
                <div class="files-to-upload-grid-container">
                    <div class="files-to-upload" v-for="(file, index) in dropFiles"
                         :key="index">
                        <div class="file-icon" id="v-step-0-5">
                            <img  v-if="getExtension(file.name) === 'image'" :src='file_type_image' alt="">
                            <img v-else-if="getExtension(file.name) === 'fbx'" :src='file_type_fbx' alt="">
                            <img v-else-if="getExtension(file.name) === 'glb'" :src='file_type_glb' alt="">
                            <img v-else :src='file_type_unknown' alt="">
                        </div>
                        <div class="file-content">
                            <h1 class="content-file-name">{{truncate(file.name, 30)}}</h1>
                            <h1 v-if="getUploadStatus(index) === 'Ready'" class="content-file-status" >Ready to Upload </h1>
                            <h1 v-else-if="getUploadStatus(index) === 'uploading'" class="content-file-status" >uploading </h1>
                            <h1 v-else-if="getUploadStatus(index) === 'uploaded'" class="content-file-status is-success" >uploaded </h1>
                            <h1 v-else class="content-file-status" >failed </h1>
                            <div class="file-upload-progress">
                                <div class="upload-progress-bar">
                                    <div class="progress" >
                                        <span class="value" :style="getCurrentUploadProgress(index)"></span>
                                    </div>
                                </div>
                                <span v-if="getUploadStatus(index) === 'Ready'"  @click="deleteDropFile(index)">
                                    <b-icon  icon="close-circle"  class="cursor-pointer" >  </b-icon>
                                </span>
                                <b-icon v-else-if="getUploadStatus(index) === 'uploading'" icon="close-circle" class="cursor-pointer" >  </b-icon>
                                <b-icon v-else-if="getUploadStatus(index) === 'uploaded'" icon="check-circle" type="is-success" class="cursor-pointer" >  </b-icon>
                                <b-icon v-else icon="alert-circle" type="is-danger" class="cursor-pointer" >  </b-icon>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="file-upload-control">

               <!--Description text box-->
                <b-input placeholder="Description" v-model="description" class="common-description" rounded id="v-step-0-6"> </b-input>

                <b-select   placeholder="Category" v-model="category" rounded expanded class="axis">
                    <option value="">--Category--</option>
                    <option value="Machine">Machine</option>
                    <option value="Automobile">Automobile</option>
                    <option value="Home Decor">Home Decor</option>
                    <option value="Character">Character</option>
                    <option value="Others">Others</option>

                </b-select>



                <!--Upload Button-->
                <button v-if="dropFiles.length === 1" type="button" class="btn-upload" @click="uploadModels()" id="btn-upload-id">Upload 1 model</button>
                <button v-else type="button" class="btn-upload" @click="uploadModels" id="btn-upload-id">Upload <b>{{dropFiles.length}} </b> models</button>

                <!--Available on app checkbox-->
                <b-checkbox v-model="availableOnApp" class="available-on-app" id="v-step-0-7">Available on App</b-checkbox>

            <div class="file-upload-control-sub">

                <!--Up Axis of the model-->
                <b-select   placeholder="Up Axis of model" v-model="model_axis" rounded expanded class="axis">
                    <option value="">--Up Axis--</option>
                    <option value="x">X</option>
                    <option value="y">Y</option>
                    <option value="z">Z</option>
                </b-select>
                <!--Unit of the model-->
                <b-select v-model="model_unit" placeholder="Measurement unit of model" class ="unit" rounded expanded>
                    <!-- <option value="">Measurement unit of model</option> -->
                    <option value="">--Measure unit--</option>
                    <option value="m">m - meter</option>
                    <option value="cm">cm - centimeter</option>
                    <option value="mm">mm - millimeter</option>
                    <option value="in">in - inch</option>
                </b-select>
            </div>

                <!--Cancel button-->
                <button v-if="isCancelAvailable" type="button" class="btn-cancel" @click="clearSelection" id="v-step-0-8">Cancel</button>
                <button v-else type="button" class="btn-cancel-disable" @click="clearSelection" disabled>Cancel</button>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "HomeModelUpload",
        data() {
            return {
                dropFiles: [],
                dummy_profile: require('@/assets/images/upload-icon.png'),
                file_type_fbx: require('@/assets/images/file-type-fbx.png'),
                file_type_glb: require('@/assets/images/file-type-glb.png'),
                file_type_image: require('@/assets/images/file-type-image.png'),
                file_type_unknown: require('@/assets/images/file-type-unknown.png'),
                file_icon:require('@/assets/images/file-type-unknown.png'),
                failedToUploadFiles: null,
                filesToUploadToServer: [],
                counter: 0,
                description: '',
                category: '',
                availableOnApp: true,
                allPromises: [],
                uploadFailedModels: [],
                isUploadingFailed: false,
                isCancelAvailable: true,

                onlyOneTime: true,

                model_axis:'',
                model_unit: ''
            }
        },
        computed: {
            noFilesSelected() {

                if(this.dropFiles.length > 0 && this.onlyOneTime && !this.$store.getters.getStopTutorial){
                    console.log("i am called!");
                    this.$tours['myTour'].currentStep = 6;
                    this.onlyOneTime = false;
                }

                return this.dropFiles.length <= 0;
            },

            getCurrentUploadProgress() {
                return index => isNaN(this.$store.state.uploadProgress[index]) ? 'width:0;' : 'width:' + this.$store.state.uploadProgress[index] + '%;';
            },

            getUploadStatus() {
                return index => !(this.$store.state.uploadStatus[index]) ? 'Ready' :
                    this.$store.state.uploadStatus[index] === 'uploading' ? 'uploading' :
                    this.$store.state.uploadStatus[index];
            }
        },
        methods: {
            deleteDropFile(index) {
                console.log("dropped!", index);
                this.dropFiles.splice(index, 1)
            },

            clearSelection() {
                if (!this.isUploadingFailed) {
                    this.dropFiles = [];
                } else {
                    this.dropFiles = [];
                    this.$store.dispatch('resetUploadProgress');
                }
            },

            uploadModels() {
                if(this.filesToUploadToServer !== this.dropFiles){
                    if(!this.$store.getters.getStopTutorial) this.$tours['myTour'].currentStep = 10;
                    this.isCancelAvailable = false;
                    this.filesToUploadToServer = this.dropFiles;
                    this.uploadMultipleModels()
                } else {
                    console.log("no new files to upload!");
                }
            },

            uploadMultipleModels() {

                let meta_data = {
                    "measure_unit" : (this.model_unit?this.model_unit:"m"),
                    "axis_up": (this.model_axis?this.model_axis:"y")
                }
                
                // console.log(this.model_unit);

                for (this.counter; this.counter < this.filesToUploadToServer.length; this.counter++) {
                    let formData = new FormData();
                    formData.append('name', this.filesToUploadToServer[this.counter].name);
                    formData.append('model_file', this.filesToUploadToServer[this.counter]);
                    formData.append('category', (this.category?this.category:"Others"));
                    formData.append('app_access', this.availableOnApp);
                    formData.append('description', !this.description ? "no description provided" : this.description);

                    this.allPromises.push(
                        this.$store.dispatch('uploadModelsToServer', {data: formData, index: this.counter, meta: meta_data})
                            .then(res => {
                                console.log("response i got: ", res);
                                if (!isNaN(res)) {
                                    this.uploadFailedModels.push(res);
                                    console.log("failed- model not uploaded")
                                } else
                                    console.log("success- model uploaded")
                            })
                            .catch(() => {
                                console.log("failed- model not uploaded")
                            })
                    )
                }

                Promise.all(this.allPromises)
                    .then(() => {
                        let retryModels = [];
                        if (this.uploadFailedModels.length > 0) {
                            for (let i = 0; i < this.uploadFailedModels.length; i++) {
                                retryModels.push(this.dropFiles[this.uploadFailedModels[i]]);
                            }
                            this.$store.dispatch('resetUploadProgress')
                                .then(() => {
                                    this.dropFiles = [];
                                    this.allPromises = [];
                                    this.failedToUploadFiles = [];
                                    this.filesToUploadToServer = [];
                                    this.uploadFailedModels = [];
                                    this.counter = 0;
                                    this.dropFiles = retryModels;
                                    this.isUploadingFailed = true;
                                    this.isCancelAvailable = true;
                                    this.$store.dispatch('updateFailedModelStatus',retryModels.length );
                                })
                                .catch(() => {
                                    this.dropFiles = [];
                                    this.allPromises = [];
                                    this.failedToUploadFiles = [];
                                    this.filesToUploadToServer = [];
                                    this.uploadFailedModels = [];
                                    this.counter = 0;
                                    this.dropFiles = retryModels;
                                    this.isUploadingFailed = true;
                                    this.isCancelAvailable = true;
                                    this.$store.dispatch('updateFailedModelStatus',retryModels.length );
                                });

                            this.$dialog.confirm({
                                title: retryModels.length +  ' file(s) failed to upload',
                                message: 'Please try again by  pressing Retry button. <br> <br> If problem persists then please file a bug report by using Contact us (coming soon)',
                                confirmText: 'Retry',
                                cancelText: 'Discard',
                                type: 'is-primary',
                                onConfirm: () => { retryModels = [] ; this.uploadModels(); },
                                onCancel: () =>  this.clearSelection()
                            });
                        } else {
                            this.$store.dispatch('resetUploadProgress')
                                .then(() => {
                                    this.dropFiles = [];
                                    this.filesToUploadToServer = [];
                                    this.counter = 0;
                                    this.isUploadingFailed = false;
                                    this.isCancelAvailable = true;
                                    if(!this.$store.getters.getStopTutorial) this.$tours['myTour'].currentStep = 12;
                                })
                                .catch(() => {
                                    this.dropFiles = [];
                                    this.filesToUploadToServer = [];
                                    this.counter = 0;
                                    this.isUploadingFailed = false;
                                    this.isCancelAvailable = true;
                                    if(!this.$store.getters.getStopTutorial) this.$tours['myTour'].currentStep = 12;
                                });

                            console.log('All models uploaded successfully')
                        }
                    })
                    .catch(() => {
                        console.log('All promises were not executed!!');
                    })


            },

            truncate(value, length) {
                return value.length > length
                    ? value.substr(0, length) + '...'
                    : value
            },

            getExtension(name){
              let extension =  name.substr(name.lastIndexOf('.') + 1) === name ? '-' : name.substr(name.lastIndexOf('.') + 1)

                switch (extension.toLowerCase()) {
                    case 'png':
                    case 'gif':
                    case 'jpeg':
                    case 'jpg':
                    case 'tiff':
                        return 'image';
                    case 'fbx':
                        return 'fbx';
                    case 'glb':
                        return 'glb';
                    default:
                        return 'unknown';
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

    @import "@/assets/css/colors.scss";

    %flex-center-content {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .home-model-upload {
        padding: 0 5%;
        width: 100%;
        height: 100%;
        overflow: hidden;

        .upload-no-file-selected {
            width: 100%;
            height: 100%;
            @extend %flex-center-content;
            padding: 5% 20%;

            .upload-no-file-selected-content {
                width: 100%;
                height: 100%;
                @extend %flex-center-content;

                .center-upload-content {
                    @extend %flex-center-content;
                    flex-direction: column;
                    width: 100%;
                    height: 100%;

                    .upload-icon {
                        width: 20%;
                        height: auto;
                        margin-bottom: 5%;
                    }
                }
            }
        }

        .upload-files-selected {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;

            .content-to-upload {
                flex: 1;
                width: 100%;
                overflow-x: hidden;
                overflow-y: overlay;

                .files-to-upload-grid-container {
                    display: grid;
                    grid-template-columns: 1fr 1fr;

                    .files-to-upload {
                        margin: 1% 5%;
                        display: flex;
                        flex-direction: row;
                        overflow: hidden;
                        padding: 1%;

                        .file-icon {
                            width: 10%;
                            height: auto;
                            margin-right: 3%;
                        }

                        .file-content {
                            width: 100%;
                            height: auto;
                            @extend %flex-center-content;
                            flex-direction: column;
                            align-items: flex-start;

                            .content-file-name {
                                margin: 1% 0;
                                font-weight: bold;
                                border: none;
                                font-family: 'Roboto Slab', sans-serif;
                                color: $primary-color;
                                text-align: center;
                                @extend %flex-center-content;
                                flex: 1;
                            }

                            .content-file-status {
                                font-weight: normal;
                                border: none;
                                font-family: 'Roboto', sans-serif;
                                font-size: 80%;
                                text-align: left;
                                flex: 1;
                            }

                            .file-upload-progress {
                                width: 100%;
                                height: 100%;
                                @extend %flex-center-content;
                                flex-direction: row;
                                flex: 1;

                                .upload-progress-bar {
                                    @extend %flex-center-content;
                                    width: 100%;
                                    height: 100%;
                                    margin-right: 2%;
                                }
                            }
                        }

                    }
                }
            }

            .file-upload-control {

                display: grid;
                grid-template-columns: 1fr 1fr 1fr;
                grid-gap: 1%;

                .btn-upload{
                    border-radius: 20px;
                    outline: none;
                    padding: 3% 1%;
                    box-sizing: border-box;
                    transition: 0.3s;
                    font-family: 'Roboto', sans-serif;
                    font-size: 110%;
                    color: white;
                    font-weight: bolder;
                    background: $primary-color;
                    cursor: pointer;
                    border: none;
                    margin: 0 0 3% 0;
                }


                .btn-cancel{
                    border-radius: 20px;
                    outline: none;
                    padding: 3% 1%;
                    box-sizing: border-box;
                    transition: 0.3s;
                    font-family: 'Roboto', sans-serif;
                    font-size: 110%;
                    color: white;
                    font-weight: bolder;
                    background: $danger-color;
                    cursor: pointer;
                    border: none;
                    margin: 0 0 3% 0;
                }

                .btn-cancel-disable{
                    border-radius: 20px;
                    outline: none;
                    padding: 3% 1%;
                    box-sizing: border-box;
                    transition: 0.3s;
                    font-family: 'Roboto', sans-serif;
                    font-size: 110%;
                    color: white;
                    font-weight: bolder;
                    background: $disable-color;
                    cursor: pointer;
                    border: none;
                }

                .common-description{
                    flex: 1;
                }
                .available-on-app{
                    margin-left: 1%;
                }
            }

            .file-upload-control-sub {

                display: grid;
                grid-template-columns: 1fr 1fr;
                grid-gap: 1%;
            }


            .progress {
                height: 0.8em;
                width: 100%;
                background-color: #c9c9c9;
                position: relative;
            }
            .progress:before {
                position: absolute;
                text-align: center;
                left: 0;
                right: 0;
            }
            .progress .value {
                background-color: $primary_color;
                display: inline-block;
                height: 100%;
                text-align: left;
                float: left;
            }
        }
    }

    .cursor-pointer {
        cursor: pointer;
    }

    .upload-more{
        margin: 2% 0;
    }

    .upload-more-content{
        padding: 2%;
    }


</style>